<template>
  <v-list-item
    :to="`/cloud/${null}/${address.uuid}`"
    @click="$store.commit('cloud/setName', address.name)"
    @contextmenu="show"
    @blur="onBlur"
  >
    <v-list-item-content>
      <v-list-item-title>
        {{ address.name }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-icon> mdi-folder </v-icon>
    </v-list-item-action>
    <CloudItemMenu
      v-model="showMenu"
      v-bind="{ x, y, address }"
      @delete-address="$emit('delete-address', $event)"
    />
  </v-list-item>
</template>
<script>
import CloudItemMenu from "./CloudItemMenu.vue";

export default {
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  components: { CloudItemMenu },
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
    };
  },

  methods: {
    onBlur() {
      setTimeout(() => {
        this.showMenu = false;
      }, 300);
    },
    show(e) {
      if (!["ADMIN", "ASSISTANT"].includes(this.$store.state.profile.role)) return;
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
  },
};
</script>
